<template>
  <div class="flex flex-col space-y-6 sm:flex-row sm:space-y-0 sm:space-x-6">
    <i v-html="$icons.error_lg" class="text-ontick-red-600"></i>
    <div class="space-y-12">
      <div class="space-y-4">
        <h2 class="text-2xl font-bold sm:text-4xl">
          Erro ao criar conta de campeonato
        </h2>
        <p class="text-gray-500 dark:text-gray-400">
          {{ data.msg }}
        </p>
      </div>
      <ontick-button @click.native="changeAccount" v-if="data.account_id">
        Ir para campeonato
      </ontick-button>
      <ontick-button @click.native="$router.push({ name: 'Dashboard' })" v-else>
        Voltar ao início
      </ontick-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },

  methods: {
    changeAccount() {
      this.$emit("changeAccount");
    },
  },

  created() {
    this.$emit("getConfig");
  },
};
</script>

<style></style>
